export default {
  props: {
    assessmentsList: Array,
  },
};
